// NOTE(!) : registration related business logic
//           is also contained here but should not
//           be. Going forward please do not add
//           logic that is not directly related
//           to the modal UI to the modal slice

import { SET_MODAL_STACK, OPEN_MODAL, CLOSE_MODAL, CLOSE_ALL_MODALS } from 'aria-viewer/modal/modalActions'
import ModalContentTypes from 'aria-viewer/modal/constants/ModalContentTypes'
import { Map, List } from 'immutable'

/*=============================================
 =                Misc Helpers                =
 =============================================*/

const isARegistrationModal = modal => {
    if (modal && modal.content && modal.content.type) {
        switch (modal.content.type) {
            case ModalContentTypes.REGISTRATION:
            case ModalContentTypes.WELCOME:
            case ModalContentTypes.WELCOME_REGISTRATION:
                return true
            default:
                return false
        }
    } else {
        return false
    }
}

/*=============================================
 =          State Helper Functions            =
 =============================================*/

/**
 * Things needed to help calculate
 * mirrored state or other redundant
 * things should be added to this
 * namespace
 */
const StateHelpers = {
    calculateRegistrationModalsOpen: state => {
        let registrationModals = {}
        state.get('modalStack').forEach(modal => {
            if (isARegistrationModal(modal)) {
                registrationModals[modal.content.type] = modal
            }
        })

        return registrationModals
    },
    getActiveRegistrationModalSource: state => {
        const registrationModals = state.get('modalStack').filter(modal => isARegistrationModal(modal))

        if (registrationModals.size > 0) {
            let modalOpen = registrationModals.get(registrationModals.size - 1)
            return modalOpen && modalOpen.content.initBy
        } else {
            return undefined
        }
    },
}

/*=============================================
 =          State Mutator Functions           =
 =============================================*/

/**
 * Anything that mutates the state should
 * be added to this namespace, since we
 * also update the mirrored data state
 * of registrationModalsOpen and
 * activeRegistrationModalSource
 */
const StateMutators = {}

/**
/* sets the entire modal stack to a new set of modals;
/* also updates any other necessary data that
/* need to be updated to mirror that e.g.
/* current registration modals and active
/* registration modal sources
 **/
StateMutators.setModals = ({ originalState, modalStack }) => {
    let newState = originalState.set('modalStack', modalStack)

    // update to reflect which registration modals are open
    newState = newState.set('registrationModalsOpen', StateHelpers.calculateRegistrationModalsOpen(newState))

    // if an active modal registration is open, have a quick
    // representation of it's trigger/source
    newState = newState.set('activeRegistrationModalSource', StateHelpers.getActiveRegistrationModalSource(newState))

    return newState
}

/*=============================================
 =          Initial State/Structure           =
 =============================================*/

const INITIAL_STATE = Map({
    modalStack: List.of(),
    modalShown: Map(),
    registrationModalsOpen: {},
    /**
     * get the trigger source of the current registration modal
     * if available
     */
    activeRegistrationModalSource: undefined,
})

/*=============================================
 =            State Slice Reducer             =
 =============================================*/

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case OPEN_MODAL:
            // parse new modal content from action
            var newlyShownModal = {
                type: action.modal.type,
                content: action.modal.content,
            }

            var modalStack = state.get('modalStack')

            return StateMutators.setModals({
                originalState: state,
                modalStack: modalStack.push(newlyShownModal),
            })

        case CLOSE_MODAL:
            var modalStack = state.get('modalStack')

            return StateMutators.setModals({
                originalState: state,
                modalStack: modalStack.pop(),
            })

        case CLOSE_ALL_MODALS:
            return StateMutators.setModals({
                originalState: state,
                modalStack: List.of(),
            })

        case SET_MODAL_STACK:
            // note: this action should theoretically
            // not be triggered directly by business logic
            return StateMutators.setModals({
                originalState: state,
                modalStack: action.modalStack,
            })

        default:
            return state
    }
}
